module.exports = __webpack_public_path__ + "static/media/inventory_management-1.4615ba36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/inventory_management-1.svg
// module id = 394
// module chunks = 0